import styled from 'styled-components'
import { ModalBody } from 'react-bootstrap'

const ModalBodyStyled = styled(ModalBody)`
  padding: 20px 50px 25px 50px;
`

export default ModalBodyStyled
